// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"SimilarProductsSlider_sliderWrapper__rsqEj"};